import DrawCanvas from './DrawCanvas';

export default DrawCanvas;
